require("jquery.flot/jquery.flot");
require("jquery.flot/jquery.flot.pie");
require("jquery.flot/jquery.flot.time");
require("jquery.flot.tooltip");